import { Component } from '@angular/core';

@Component({
  selector: 'lx-quote-course-details-label',
  templateUrl: './quote-course-details-label.component.html',
  styleUrls: ['./quote-course-details-label.component.scss'],
})
export class QuoteCourseDetailsLabelComponent {}
